import { useMemo } from 'react';
import { bannersAdapter } from '../libs/bannerAdapter';
import { useQuery } from '@tanstack/react-query';
import { homeAPI } from '../api/homeAPI';
import { useTranslation } from 'react-i18next';
import { BannerLanguage } from '../types/Banner';

export const useGetBanners = (branch?: number) => {
  const { i18n } = useTranslation();
  const language = (i18n.language || localStorage.getItem('language') || 'uz') as BannerLanguage;
  const initData = useMemo(() => ({ banners: bannersAdapter([], language) }), [language]);

  const { data = initData, isLoading } = useQuery({
    // Филиал в ключе: подборка баннеров своя у каждого, без него кэш от одного
    // филиала показывался бы в другом.
    queryKey: ['banners', language, branch],
    // Без филиала (нет адреса, геолокация выключена) запрос всё равно уходит —
    // просто без branch_id: иначе на главной не было бы баннеров вообще.
    queryFn: async () => await homeAPI.getBanners(branch),
    select: data => ({
      banners: bannersAdapter(data.data?.banners, language),
    }),
  });
  return {
    ...data,
    isLoading,
  };
};
